import React, { useState, useEffect } from "react";
import ActionFlow from "../../Assets/action-flow.svg";
import Assets from "../../Assets/assets.svg";
import Queues from "../../Assets/queues.svg";
import Schedules from "../../Assets/schedules.svg";
import { totalCount } from "../../Redux/actions/dashboard";
import "./index.css";

function TotalCount(props) {

    let [actionFlows, setActionFlows] = useState(0);
    let [assets, setAssets] = useState(0);
    let [queues,setQueues] = useState(0);
    let [schedules,setSchedules] = useState(0);

    useEffect(() => {
        document.title = "Dashboard | E-Manager Console | Techforce.ai";
        const fetchData = async () => {
            let data = await totalCount();
            if(data){
                setActionFlows(data.totalBots)
                setAssets(data.totalSecretVault)
                setQueues(data.totalQueues)
                setSchedules(data.totalSchedules)
            }
        };
        fetchData();
    },[])
    
    return (
        <div className="main-content">
            <div className="total">
                <div className="row" >
                    <div className="col-md-3 col-xs-6 ib-1">
                        <div className="card-white">
                            <div className="icon-block">
                                <div className="icon">
                                    <a href="/processes"> 
                                        <img src={ActionFlow}  alt="logo"></img>
                                    </a>
                                </div>
                                <div className="icon-text">
                                    <a href="/processes"><h3>{actionFlows}</h3></a>
                                    <a href="/processes"><span>Action Flows</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-xs-6 ib-1">
                        <div className="card-white">
                            <div className="icon-block">
                                <div className="icon">
                                    <a href="/vault"> 
                                        <img src={Assets}  alt="logo"></img>
                                    </a>
                                </div>
                                <div className="icon-text">
                                    <a href="/vault"><h3>{assets}</h3></a>
                                    <a href="/vault"><span>Assets</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-xs-6 ib-1">
                        <div className="card-white">
                            <div className="icon-block">
                                <div className="icon">
                                    <a href="/queues"> 
                                        <img src={Queues}  alt="logo"></img>
                                    </a>
                                </div>
                                <div className="icon-text">
                                    <a href="/queues"><h3>{queues}</h3></a>
                                    <a href="/queues"><span>Queues</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 col-xs-6 ib-1">
                        <div className="card-white">
                            <div className="icon-block">
                                <div className="icon">
                                    <a href="/schedules"> 
                                        <img src={Schedules}  alt="logo"></img>
                                    </a>
                                </div>
                                <div className="icon-text">
                                    <a href="/schedules"><h3>{schedules}</h3></a>
                                    <a href="/schedules"><span>Schedules</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    );
}

export default TotalCount;
